import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doublecheck",
  "use": "icon-doublecheck-usage",
  "viewBox": "0 0 24 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 13\" id=\"icon-doublecheck\">\n    <path fill=\"#465669\" d=\"M16.4 0l-5.984 5.784 1.45 1.401 5.984-5.784L16.4 0zm6.15 0L12 10.198 7.6 5.945l-1.45 1.4L12 13 24 1.401 22.55 0zM1.45 5.945L0 7.345l5.383 5.206 1.452-1.403-5.386-5.203z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol